import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Notification, useLocalizeMessage } from 'libs.nucleus';
import { getConsentArchiveBannerStorageKey, readArchiveBannerDismissState, shouldShowArchiveBanner, writeArchiveBannerDismissState, } from '../../helpers/archive_banner.helpers';
export const ConsentArchiveBanner = ({ environmentId, siteId, summary }) => {
    const translate = useLocalizeMessage();
    const storageKey = environmentId != null && siteId ? getConsentArchiveBannerStorageKey(environmentId, siteId) : null;
    const [dismissed, setDismissed] = useState(() => readArchiveBannerDismissState(storageKey));
    const [dismissStorageKey, setDismissStorageKey] = useState(storageKey);
    if (storageKey !== dismissStorageKey) {
        setDismissStorageKey(storageKey);
        setDismissed(readArchiveBannerDismissState(storageKey));
    }
    const isVisible = useMemo(() => shouldShowArchiveBanner(summary?.archivedTemplateCount, dismissed), [dismissed, summary?.archivedTemplateCount]);
    if (!isVisible || !summary) {
        return null;
    }
    const handleClose = () => {
        if (!storageKey) {
            return;
        }
        const next = { dismissedCount: summary.archivedTemplateCount };
        writeArchiveBannerDismissState(storageKey, next);
        setDismissed(next);
    };
    return (_jsx("div", { className: 'mb-6', "data-testid": 'consent-archive-banner', children: _jsx(Notification, { variant: 'inline', type: 'warning', customIcon: 'warning', title: translate('info.consent_archive.banner.title'), subtitle: _jsx("span", { className: 'nucleus-text-sm nucleus-text-text-warning', children: translate('info.consent_archive.banner.body', { count: summary.archivedTemplateCount }) }), closeable: true, onClose: handleClose }) }));
};
